import axios from 'axios';
import cookie from 'js-cookie';
import { omitBy, isUndefined } from 'lodash';
import store from '@/store';
import router from '@/router';
import {
  STORAGE_KEY_TOKEN,
} from '@/consts';
import {
  TOKEN_INVALID,
} from '@/consts/error';

function redirectToLogin() {
  router.replace(process.env.LOGIN_PATH);
}

export const getAuthHeaders = () => omitBy({
  Authorization: cookie.get(STORAGE_KEY_TOKEN),
  type: 'unioncenter',
}, isUndefined);

const instance = axios.create({
  baseURL: '/api',
  timeout: 10 * 60 * 1000,
});

instance.interceptors.request.use(
  (config) => {
    const {
      headers,
      ...restConfig
    } = config;
    store.commit('loadingStart');
    let loginheader = {};
    if (config.url === '/unioncenter/web-background/account/login') {
      loginheader = {
        'LOGIN-TYPE': 'MERCHANT',
      };
    }
    return {
      headers: {
        ...headers,
        ...getAuthHeaders(),
        ...loginheader,
      },
      ...restConfig,
    };
  },
  err => Promise.reject(err),
);

// Add a response interceptor
instance.interceptors.response.use(
  (response) => {
    const {
      data,
      success,
      errorCode,
      msg,
      code,
    } = response.data;
    // 判断返回是否是文件类型
    store.commit('loadingEnd');
    if (typeof response.data === 'string' || response.data instanceof Blob) {
      const startIndex = response.headers['content-disposition'].indexOf('filename=') + 9;
      const filename = decodeURIComponent(
        response.headers['content-disposition'].slice(startIndex),
      );
      return {
        blob: response.data,
        filename,
      };
    }

    // 接口失败
    if (!success) {
      // 处理登录过期
      if (errorCode === TOKEN_INVALID) {
        redirectToLogin();
      }

      if (Number(code) === 200) {
        return data;
      }

      if ([600001].includes(Number(code))) {
        return response.data;
      }

      return Promise.reject(new Error(msg));
    }

    return data; // 普通接口，请求成功，data 为 null
  },
  (error) => {
    if (error.response) {
      store.commit('loadingEnd');
      if (error.response.status === 401) {
        redirectToLogin();
      }
    }

    return Promise.reject(error);
  },
);

export default instance;
